/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_This_RangeInputs */

const en_ui_volume_this_range = /** @type {(inputs: Ui_Volume_This_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This range`)
};

const de_ui_volume_this_range = /** @type {(inputs: Ui_Volume_This_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "This range" |
*
* @param {Ui_Volume_This_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_this_range = /** @type {((inputs?: Ui_Volume_This_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_This_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_this_range(inputs)
	return de_ui_volume_this_range(inputs)
});